import http from '@/util/http'
// import { jsonToParam } from '@/util/tool'
// 待反馈列表根据询价状态条件模糊搜索
export function queryAllOrderManuallnquiry (miState, page, size, data) {
  return http({
    url: `/api/orderManualInquiry/queryAllOrderManuallnquiry/${miState}/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 待配货根据条件模糊查询(分页)
export function queryByProcessState (type, page, size, data) {
  return http({
    url: `/api/orderContractStockup/queryByProcessState/${type}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 待审核付款申请列表
export function queryRequestPayList (state, page, size, data) {
  return http({
    url: `/api/financePay/queryRequestPayList/${state}/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 待审核付款申请列表认领,提取接口
export function updateProcessid (state, type, data, urlex) {
  return http({
    url: `/api/financePay/${urlex}/${state}/${type}`,
    method: 'post',
    data: data
  })
}

// 待审核付款申请列表认领,提取接口
export function updateProcessidex (state, data, urlex) {
  return http({
    url: `/api/financePayRequestSource/${urlex}/${state}`,
    method: 'post',
    data: data
  })
}
// 待审核付款申请提交
export function updateStateByFbrIdli (data) {
  return http({
    url: '/api/financePay/updateStateByFbrId',
    method: 'post',
    data: data
  })
}
// 选择承兑汇票
export function queryAllByState (page, size, data) {
  return http({
    url: `/api/financeAcceptanceBill/queryAllByState/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 付款详情
export function ByPayNumber (payNumber, type, data) {
  return http({
    url: `/api/financePay/queryPayRequestByPayNumber/${payNumber}/${type}`,
    method: 'post',
    data: data
  })
}
// 待审核付款审核中的银行转账
export function financeBankInfo () {
  return http({
    url: '/api/financeBankInfo/queryAll',
    method: 'get'

  })
}
// 待付款申请列表--承兑汇票
export function queryPayRequestSourceByBill (state, page, size, data) {
  return http({
    url: `/api/financePayRequestSource/queryPayRequestSourceByBill/${state}/${page}/${size}`,
    method: 'post',
    data
  })
}
// 待付款申请列表--银行转账
export function queryPayRequestSourceByBank (state, page, size, data) {
  return http({
    url: `/api/financePayRequestSource/queryPayRequestSourceByBank/${state}/${page}/${size}`,
    method: 'post',
    data
  })
}
// 根据待处理付款付款详情申请id查询
export function queryByFprsId (fprsId, data) {
  return http({
    url: `/api/financePayRequestSource/queryByFprsId/${fprsId}`,
    method: 'post',
    data: data
  })
}
// 待处理银行对账单列表--银行转账
export function queryBankInfoListByState (state, page, size, data) {
  return http({
    url: `/api/finaceBankReceipt/queryBankInfoListByState/${state}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 根据待处理付款付款详情申请id查询
export function queryByFbrId (fprsId, data) {
  return http({
    url: `/api/finaceBankReceipt/queryByFbrId/${fprsId}`,
    method: 'post',
    data: data
  })
}
// 其他付款申请列表
export function queryListByState (state, page, size, data) {
  return http({
    url: ` /api/finaceAcceptanceReceipt/queryBankInfoListByState/${state}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 其他付款申请详情
export function queryBankInfoList (farId, data) {
  return http({
    url: ` /api/finaceAcceptanceReceipt/queryBankInfoListByState/${farId}`,
    method: 'post',
    data: data
  })
}
// 其他付款提交
export function updateStateByFbrIdupdata (data, query) {
  return http({
    url: '/api/finaceAcceptanceReceipt/updateStateByFbrId',
    method: 'post',
    params: query,
    data: data
  })
}

// 承兑汇票管理列表
export function queryAcceptanceBillListByStatebill (state, page, size, data) {
  return http({
    url: `/api/financeAcceptanceBill/queryAcceptanceBillListByState/${state}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
//  贴现作废
export function updateById (data, urlex = 'updateById') {
  return http({
    url: `/api/financeAcceptanceBill/${urlex}`,
    method: 'post',
    data: data
  })
}
// 承兑汇票收款管理列表
export function queryAcceptanceBillListByState (state, page, size, data) {
  return http({
    url: `/api/financeAcceptanceBillRequest/queryAcceptanceBillListByState/${state}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 承兑汇票收款管理详情
export function queryByOrderId (fabrId, data) {
  return http({
    url: `/api/financeAcceptanceBillRequest/queryByOrderId/${fabrId}`,
    method: 'post',
    data: data
  })
}
// 承兑汇票收款管理详情提交
export function updateStateByFbrIdup (state, processState, data = {}) {
  return http({
    url: `/api/financeAcceptanceBillRequest/updateStateByFbrId/${state}/${processState}`,
    method: 'post',
    data: data
  })
}
// 财务开票管理列表
export function queryInvoiceByFinance (state, page, size, data) {
  return http({
    url: ` /api/orderContractInvoice/queryInvoiceByFinance/${state}/${page}/${size}`,
    method: 'post',
    data: data
  })
}

//  财务收票管理列表
export function queryByFinance (type, page, size, data) {
  return http({
    url: `/api/purchaseContractInvocie/queryByFinance/${type}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 财务收票认领
export function updateStateByPciId (data, processState, state, urlex = 'updateStateByPciId') {
  return http({
    url: `/api/purchaseContractInvocie/${urlex}`,
    method: 'post',
    params: {
      processState: processState,
      state: state
    },
    data: data
  })
}
// 普通发票退票管理
export function querySubInvoiceByFinance (type, state, page, size, data) {
  return http({
    url: `/api/orderContractInvoiceSub/querySubInvoiceByFinance/${type}/${state}/${page}/${size}`,
    method: 'post',

    data: data
  })
}

// 普通发票/红字发票 退票管理id详情
export function queryByFinanceid (oisId, type) {
  return http({
    url: `/api/orderContractInvoiceSub/queryByFinance/${oisId}/${type}`,
    method: 'get'
  })
}

// 审核/提取/领取退票/红字发票申请
export function updateStateByFprsIdwrit (data, obj, str) {
  return http({
    url: `/api/orderContractInvoiceSub/${str}`,
    method: 'post',
    params: obj,
    data
  })
}
// 处理普通退票
export function updateStateBySub (data, state) {
  return http({
    url: '/api/orderContractInvoiceSub/updateStateBySub',
    method: 'post',
    params: { state },
    data
  })
}
// 处理红字退票
export function updateStateByRed (data) {
  return http({
    url: '/api/orderContractInvoiceSub/updateStateByRed',
    method: 'post',
    data: data
  })
}
// 退票修改物流信息
export function updateLogisticsById (data, type) {
  return http({
    url: `/api/orderContractInvoiceSub/updateLogisticsById/${type}`,
    method: 'post',
    data: data
  })
}

// 余额管理列表
export function queryCustomerByFinance (page, size, data) {
  return http({
    url: `/api/customerAccountBase/queryCustomerByFinance/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 供应商余额列表
export function querySupplierByFinance (page, size, type, data) {
  return http({
    url: `/api/supplierAcountBase/querySupplierByFinance/${page}/${size}/${type}`,
    method: 'post',
    data: data
  })
}
// 银行待处理的提交接口
export function updateStateByFprsId (data) {
  return http({
    url: '/api/financePayRequestSource/updateStateByFprsId',
    method: 'post',
    data: data
  })
}
// 银行对账单收款处理待审核的提交接口
export function updateStateByFbrId (confirmState, data, state, urlex) {
  return http({
    url: `/api/finaceBankReceipt/${urlex}`,
    method: 'post',
    params: {
      state: state,
      confirmState: confirmState
    },
    data: data
  })
}
// 承兑汇票查看详情
export function queryAcceptanceBillByFabId (fprsId, type, data) {
  return http({
    url: `/api/financeAcceptanceBill/queryAcceptanceBillByFabId/${type}/${fprsId}`,
    method: 'post',
    data: data
  })
}
// 添加汇票接口
export function addBill (data) {
  return http({
    url: '/api/financeAcceptanceBill/add',
    method: 'post',
    data: data
  })
}
// 处理承兑汇票的提交接口
export function updateStateByFbrIdstate (state, processState, data = {}, urlex) {
  return http({
    url: `/api/financeAcceptanceBillRequest/${urlex}/${state}/${processState}`,
    method: 'post',
    data: data
  })
}
// 批量认领承兑汇票申请
export function updateStateByFbrIdClaimAll (data) {
  return http({
    url: '/api/financeAcceptanceBillRequest/updateStateByFbrIdClaimAll',
    method: 'post',
    data: data
  })
}
// 坏账列表
export function queryFinanceBadDebtListByState (state, page, size, data) {
  return http({
    url: ` /api/financeBadDebt/queryFinanceBadDebtListByState/${state}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 坏账id详情
export function queryFinanceBadDebtByFbdId (fbcId) {
  return http({
    url: `/api/financeBadDebt/queryFinanceBadDebtByFbdId/${fbcId}`,
    method: 'get'

  })
}
// 处理待审核坏账申请
export function updateStateByFbdId (fbdId, state) {
  return http({
    url: `/api/financeBadDebt/updateStateByFbdId/${fbdId}`,
    method: 'post',
    params: {
      processState: null,
      state: state
    }
  })
}
// 提取 认领 待审核坏账申请
export function financeBadDebtA (data, processState, str) {
  return http({
    url: `/api/financeBadDebt/${str}`,
    method: 'post',
    data,
    params: {
      processState
    }
  })
}
// 财务开票id详情
export function queryByOciId (ociId, data) {
  return http({
    url: `/api/orderContractInvoice/queryByOciId/${ociId}`,
    method: 'post',
    data: data
  })
}
// 财务开票id修改
export function updateCodeByOciId (ociId, invoiceCode) {
  return http({
    url: `/api/orderContractInvoice/updateCodeByOciId/${ociId}/${invoiceCode}`,
    method: 'post'
  })
}
// 财务提交接口
export function updateStateByOcrId (data, state, processState) {
  return http({
    url: '/api/orderContractInvoice/updateStateByOcrId',
    method: 'post',
    params: {
      state: state,
      processState
    },
    data: data
  })
}
// 财务提取/认领接口
export function updateStateByOcrIddraw (data, processState, state, urlex = 'updateStateByOcrId') {
  return http({
    url: `/api/orderContractInvoice/${urlex}`, // updateStateByOcrId
    method: 'post',
    params: {
      processState: processState,
      state: state
    },
    data
  })
}
// 财务收票详情
export function queryPurchaseContractInvociesListVo (invoiceReceiveNumber, data) {
  return http({
    url: `/api/purchaseContractInvocie/queryPurchaseContractInvociesListVo/${invoiceReceiveNumber}`,
    method: 'post',
    data: data
  })
}
// 物流费用列表
export function queryPageAllByState (state, page, size, data) {
  return http({
    url: ` /api/financeLogistic/queryPageAllByState/${state}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 欠款客户列表(财务)
export function queryTransFlowByOcbId (type, page, size, data) {
  return http({
    url: `/api/orderContractBase/queryTransFlowByOcbIdFinance/${type}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 获取产品分类右侧列表
export function queryAllProductClassBylevel (level, page, size, data) {
  return http({
    url: `/api/productClass/queryAllProductClassBylevelAndVo/${level}/${page}/${size}`,
    method: 'post',
    data,
    params: {
      id: ''
    }
  })
}
// 修改 品类
export function updateByIdus (data) {
  return http({
    url: '/api/productClass/updateById',
    method: 'post',
    data: data
  })
}
// 开票设置
export function updateInvocieAmountLimit (num) {
  return http({
    url: '/api/financeSetting/updateInvocieAmountLimit',
    method: 'post',
    params: {
      invocieAmountLimit: num
    }
  })
}
// 调整金额(客户)
export function moneyadd (data) {
  return http({
    url: '/api/customerBalanceApproval/add',
    method: 'post',
    data: data
  })
}
// 调整金额(供应商)
export function supplierBalanceApproval (data) {
  return http({
    url: 'api/supplierBalanceApproval/add',
    method: 'post',
    data: data
  })
}
//  客户 收支记录
export function queryCustomerAccountByFinance (cusId, page, size, data) {
  return http({
    url: `/api/customerAccountBaseContent/queryCustomerAccountByFinance/${cusId}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
//  供应商 收支记录
export function querySupplierAccountByFinance (suId, type, page, size, data) {
  return http({
    url: `/api/supplierAccountBaseContent/querySupplierAccountByFinance/${suId}/${type}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 快递物流id详情
export function queryById (flId) {
  return http({
    url: `/api/financeLogistic/queryById/${flId}`,
    method: 'get'
  })
}
// 快递物流填写
export function updateByIdLog (data) {
  return http({
    url: '/api/financeLogistic/updateById',
    method: 'post',
    data: data
  })
}
// 快递物流新增
export function addLog (data) {
  return http({
    url: '/api/financeLogistic/add',
    method: 'post',
    data: data
  })
}
// 获取角色和部门
export function allRole () {
  return http({
    url: '/api/staffBase/queryAll',
    method: 'get'
  })
}

/*
*
*
* */

export function getComAll () {
  return http({
    url: '/api/comOrganization/queryComAll',
    method: 'get'
  })
}
// 系统设置-查看资金占用比例设置
export function queryFinanceSetting () {
  return http({
    url: '/api/financeSetting/queryFinanceSetting',
    method: 'post'
  })
}

// 财务合并开票
export function updateInvoiceCodeByOcrId (data) {
  return http({
    url: ' /api/orderContractInvoice/updateInvoiceCodeByOcrId',
    method: 'post',
    data: data
  })
}

// 查看物流单号是否重复
export function isItRedundant (logicNumber) {
  return http({
    url: `/api/financeLogistic/isItRedundant/${logicNumber}`,
    method: 'get'
  })
}

export function financeUploadFile (data) {
  return http({
    url: '/api/systemAttachment/uploadFinanceDraft',
    method: 'post',
    data
  })
}

// 财务-收票申请导出
export function financeExportReceiptApplication (data) {
  return http({
    url: '/api/financeSetting/financeTicketCoeDerive',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 财务余额管理-导出
export function financeBalanceCoeDerive (data) {
  return http({
    url: '/api/financeSetting/financeBalanceCoeDerive',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 财务我的 红字发票导出
export function financeCreditCoeDerive (data) {
  return http({
    url: '/api/financeSetting/orderInvoiceCoeDerive',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 财务我的待处理 退票导出
export function financeRefundTicketCoeDerive (data) {
  return http({
    url: '/api/financeSetting/financeRefundTicketCoeDerive',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 财务物流&快递费用导入-确认
export function addImportLogistic (data) {
  return http({
    url: '/api/financeLogistic/addImportLogistic',
    method: 'post',
    data
  })
}
// 财务物流快递费用导出
export function financeLogisticCoeDerive (data) {
  return http({
    url: '/api/financeLogistic/financeLogisticCoeDerive',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 财务物流快递费用导出
export function queryFinancelogistic () {
  return http({
    url: '/api/SystemOpenController/queryFinancelogistic',
    method: 'post'
  })
}
/**
 * @author: wf
 * @createdate: 2021-01-19 13:22
 * @mark: 查询所有客户
 */
export function getAllCustomer (data) {
  return http({
    url: '/api/customerBase/queryAll',
    method: 'post',
    data
  })
}

/**
 * @author: wf
 * @createdate: 2021-01-19 13:36
 * @mark: 根据客户id查询账户信息
 */
export function getAccountByCustomerId (data = {}) {
  return http({
    url: `/api/customerBase/queryCustomerBankByCsId/${data.cusId}`,
    method: 'post'
  })
}

/**
 * @author: wf
 * @createdate: 2021-01-19 15:34
 * @mark: 银行对账收款新增
 */
export function addbankBill (data = {}, id) {
  return http({
    url: `/api/finaceBankReceipt/add/${id}`,
    method: 'post',
    data
  })
}

// 财务开票管理 - 开票记录导出
export function financeInvoicedExport(data) {
  return http({
    url: '/api/orderContractInvoice/financeInvoicedExport',
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 财务收票管理 - 收票记录
export function financeReceiptExport(data) {
  return http({
    url: '/api/purchaseContractInvocie/financeReceiptExport',
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 欠款客户清单-导出清单
export function exportArrearsCustomers (data) {
  return http({
    url: '/api/orderContractBase/exportArrearsCustomers',
    method: 'post',
    responseType: 'blob',
    data
  })
}
